<div class="app-input-validation" [ngClass]="className"
     *ngIf="condition">
  {{message | translate}}
  <i class="material-icons" *ngIf="className === 'error'">clear</i>
</div>
